import {ReactElement} from 'react';
import {Box} from '@mui/material';
import {TFunction} from 'i18next';
import AddToHomeItem from './AddToHomeItem';
import MenuItem, {MenuItemType} from './MenuItem';

type Props = {
  menuItems: MenuItemType[];
  onCloseSidebar?: () => void;
  t: TFunction;
};

function Menu({menuItems, onCloseSidebar, t}: Props): ReactElement {
  return (
    <Box
      data-testid="userSidebarMenu"
      sx={{
        mt: 2,
        mb: 1
      }}
    >
      {menuItems.map((menuItem) => (
        <MenuItem
          key={menuItem.link}
          menuItem={menuItem}
          onlyIcon={false}
          onClick={onCloseSidebar}
          t={t}
        />
      ))}
      <Box
        sx={{
          mt: 2,
          mb: 1
        }}
      >
        <AddToHomeItem t={t} />
      </Box>
    </Box>
  );
}

export default Menu;
